import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { CloseButton } from './buttons';

const StyledDiv = styled.div`
  max-width: 280px !important;
`;

type InternalHeaderProps = Readonly<{
  clientId?: string;
  clientName?: string;
  quoteId: string;
  onClosed: () => void;
}>;

export const InternalTileHeader: FC<InternalHeaderProps> = ({ clientId, clientName, quoteId, onClosed }) => {
  const { formatMessage } = useIntl();
  const hasClient = !!clientId && !!clientName;
  const clientLabel = useMemo(
    () => (hasClient ? clientName : formatMessage({ id: 'dashboard.noClient' })),
    [clientName, formatMessage, hasClient],
  );

  return (
    <div className="d-flex p-2 justify-content-between">
      <StyledDiv className="d-flex flex-column mt-2 ms-2">
        <h6
          className={classNames('text-truncate  mb-1', {
            'text-muted': !hasClient,
          })}
          data-e2e="client-name"
          title={formatMessage({ id: 'client' }, { clientName: clientLabel })}
        >
          {clientLabel}
        </h6>
        <div className="text-secondary fw-medium d-flex flex-row align-items-center">
          {hasClient && (
            <>
              <span data-e2e="client-id" title={formatMessage({ id: 'client.id' })}>
                {clientId}
              </span>
              <span className="px-1">-</span>
            </>
          )}
          <span data-e2e="quoteId" title={formatMessage({ id: 'quoteId' })}>
            {quoteId}
          </span>
        </div>
      </StyledDiv>
      <CloseButton onClosed={onClosed} />
    </div>
  );
};
